// Fetch request
import fetch from '../../core/fetch';
import gql from 'graphql-tag';

export const topListingsQ = gql`
  query getTopListings($categoryIds: [Int]) {
    TopListings(categoryIds: $categoryIds) {
      results {
        id
        title
        coverPhotoName
        description
        basePrice
        category
        reviewsCount
        reviewScore
        city
        state
      }
    }
  }
`;

export const getByCategoryQ =
  //$geography: String,
  //Room type has been hijacked to be category
  gql`
    query($roomType: [Int]) {
      SearchListing(roomType: $roomType) {
        count
        results {
          id
          title
          description
          lat
          lng
          city
          state
          coverPhotoName
          reviewsCount
          reviewsStarRating
          listPhotos {
            id
            name
            type
            status
          }
          basePrice
          category
          wishListStatus
          isListOwner
        }
      }
    }
  `;

async function getByCategory(values) {
  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
      variables: values,
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data && data.SearchListing) {
    return data.SearchListing;
    //dispatch(showResults());
  }
  return null;
}

export default getByCategory;



// WEBPACK FOOTER //
// ./src/routes/home/getByCategoryQ.js